export const BUILD_ID = 'App Version: 1.0.0 (190) STA'
